import { Euler, Quaternion, Vector2 } from 'three';
export var Direction;
(function (Direction) {
    Direction[Direction["North"] = 0] = "North";
    Direction[Direction["East"] = 1] = "East";
    Direction[Direction["South"] = 2] = "South";
    Direction[Direction["West"] = 3] = "West";
})(Direction || (Direction = {}));
;
export var Turn;
(function (Turn) {
    Turn[Turn["Left"] = -1] = "Left";
    Turn[Turn["Right"] = 1] = "Right";
})(Turn || (Turn = {}));
const forwardVectors = [
    new Vector2(0, -1),
    new Vector2(1, 0),
    new Vector2(0, 1),
    new Vector2(-1, 0),
];
export function dirForward(dir) {
    return forwardVectors[dir];
}
export function dirTurn(dir, turn) {
    let newDir = dir + turn;
    while (newDir < 0) {
        newDir += 4;
    }
    return newDir % 4;
}
const rotations = [
    new Quaternion().setFromEuler(new Euler(0, Math.PI, 0)),
    new Quaternion().setFromEuler(new Euler(0, Math.PI / 2, 0)),
    new Quaternion().setFromEuler(new Euler(0, 0, 0)),
    new Quaternion().setFromEuler(new Euler(0, Math.PI * 1.5, 0)),
];
export function dirRotation(dir) {
    return rotations[dir];
}
export function dirOpposite(dir) {
    return dirTurn(dir, 2);
}
